/* eslint-disable no-undef */
import VanillaModal from "/Assets/libs/Modal/VanillaModal.js";
import { getCookie } from "/Assets/js/utilities.js";

document.addEventListener("DOMContentLoaded", () => {
    const idc = document.querySelector(".image-download-center");
    if (!idc) return;
    const imageDownloadCenter = new ImageDownloadCenter();
    imageDownloadCenter.init();
});

class ImageDownloadCenter {
    constructor() {
        this.cancelURL = window.cancelURL;
        this.chkPassURL = chkPassURL;
        this.incorrectPass = incorrectPass;
        this.errorerrorhasoccured = errorerrorhasoccured;
        this.errorMessage = document.getElementById("errorMessage");
        this.password = document.getElementById("password");
        this.idcModal;
    }

    init() {
        // Check for the presence of the 'idcauth' cookie
        const idcAuthCookie = getCookie("IDCAuth");
        if (idcAuthCookie) {
            return;
        }

        const idcModal = new VanillaModal("imageDownloadCenterLoginPopup", { dissmissable: false });
        this.idcModal = idcModal;
        this.idcModal.open();

        document.querySelector(".imageDownloadCenterLoginForm button.cancel").addEventListener("click", (e) => {
            e.preventDefault();
            window.location.href = self.cancelURL;
        });

        document.querySelector(".imageDownloadCenterLoginForm").addEventListener("submit", (event) => {
            event.preventDefault();
            this.handleSubmit();
        });
    }

    handleSubmit() {
        const form = document.querySelector(".imageDownloadCenterLoginForm");
        const data = new URLSearchParams(new FormData(form)).toString();

        fetch(this.chkPassURL, {
            method: "POST",
            headers: {
                "Content-Type": "application/x-www-form-urlencoded"
            },
            body: data
        })
            .then(response => response.json())
            .then(data => {
                if (data === "incorrect") {
                    this.errorMessage.innerHTML = `<p class="error">${this.incorrectPass}</p>`;
                } else {
                    this.idcModal.close();
                }
            })
            .catch(() => {
                this.errorMessage.innerHTML = `<p class="error">${this.errorerrorhasoccured}</p>`;
            });
    }
}
